import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { RealEstateOwnedStepComponent } from "../../wizard/wizard-steps/reo-step/reo-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class RealEstateOwnedStep extends WizardStepBase {

  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = RealEstateOwnedStepComponent;
  }
}
